import React from "react";

const Modal = ({ closeModal, children }) => {
  // Close the modal when the overlay is clicked
  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      closeModal();
    }
  };

  // Close the modal when the escape key is pressed
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      closeModal();
    }
  };

  return (
    <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-black bg-opacity-75" onClick={handleOverlayClick} onKeyDown={handleKeyDown}>
      <div className="bg-white rounded-lg p-6 max-w-md max-h-96 overflow-y-auto">
        {children}
        <button className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg" onClick={closeModal}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Modal;
